import i18n from "../../../../../i18n";
import { SECOND_FLOOR_CD_IMG } from "../../floor_images";
import elevator from "../../elevator_positions";

let second_floor_locations;
export default second_floor_locations = [
  // {
  //   floor: i18n.t("second_floor"),
  //   imageURL: SECOND_FLOOR_CD_IMG,
  //   title: "217",
  //   marked_position_x: 189,
  //   marked_position_y: 118,
  // },
  // {
  //   floor: i18n.t("second_floor"),
  //   imageURL: SECOND_FLOOR_CD_IMG,
  //   title: "220",
  //   marked_position_x: 218,
  //   marked_position_y: 121,
  // },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "221",
    marked_position_x: 212,
    marked_position_y: 95,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "222",
    marked_position_x: 245,
    marked_position_y: 80,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "223",
    marked_position_x: 265,
    marked_position_y: 83,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "225",
    marked_position_x: 285,
    marked_position_y: 83,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "226",
    marked_position_x: 305,
    marked_position_y: 83,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "227",
    marked_position_x: 328,
    marked_position_y: 83,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "228",
    marked_position_x: 320,
    marked_position_y: 117,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "230",
    marked_position_x: 320,
    marked_position_y: 137,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "231",
    marked_position_x: 320,
    marked_position_y: 157,
  },
  {
    floor: i18n.t("second_floor"),
    imageURL: SECOND_FLOOR_CD_IMG,
    ...elevator.library,
    title: "232",
    marked_position_x: 315,
    marked_position_y: 192,
  },
  // {
  //   floor: i18n.t("second_floor"),
  //   imageURL: SECOND_FLOOR_CD_IMG,
  //   title: "233",
  //   marked_position_x: 283,
  //   marked_position_y: 175,
  // },
  // {
  //   floor: i18n.t("second_floor"),
  //   imageURL: SECOND_FLOOR_CD_IMG,
  //   title: "234-235",
  //   marked_position_x: 233,
  //   marked_position_y: 179,
  // },
];
